import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.css';
import { ToastProvider } from 'react-toast-notifications';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { HashRouter } from 'react-router-dom';
import configureStore from './store/ConfigStore';
import AuthBootstrap from './components/auth/AuthBootstrap';

/**
 * Paper.js is imported by the components that draw; it is deliberately NOT
 * installed onto `window`.
 *
 * paper.install(window) copied 14+ of its classes over browser globals —
 * including Event, MouseEvent and, fatally, Symbol. With Symbol replaced,
 * Symbol.iterator no longer exists, so Babel's iterable helper threw
 * "Invalid attempt to iterate non-iterable instance"; with Event replaced,
 * any library constructing DOM events broke. That is what made Google
 * sign-in fail in four different disguises. Every component that uses Paper
 * imports it directly, so nothing needs the globals.
 */

// Alert "ping": synthesized with the Web Audio API so it works offline in
// Electron with no external asset (the previous Google-Drive URL failed to load
// with NotSupportedError). Exposed as window.audio.play() to keep every existing
// call site (`window.audio.play()`) working unchanged.
window.audio = {
  play() {
    try {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return;
      if (!window._alertAudioCtx) window._alertAudioCtx = new Ctx();
      const ctx = window._alertAudioCtx;
      if (ctx.state === 'suspended') ctx.resume();
      const now = ctx.currentTime;
      const osc = ctx.createOscillator();
      const gain = ctx.createGain();
      osc.type = 'sine';
      osc.frequency.value = 880;
      gain.gain.setValueAtTime(0.0001, now);
      gain.gain.exponentialRampToValueAtTime(0.2, now + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.25);
      osc.connect(gain).connect(ctx.destination);
      osc.start(now);
      osc.stop(now + 0.26);
    } catch (e) {
      /* audio is a non-critical enhancement — never let it break a flow */
    }
  },
};

const { store, persistor } = configureStore();

// Alerts close on their own after 10 s; the user can still close one earlier.
const ALERT_DISMISS_MS = 10000;

// PasswordGate is no longer a wrapper: it is the /access route of the auth
// flow, which App routes to. Wrapping the whole app in it would gate every
// route behind the old tester screen.
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <ToastProvider autoDismiss autoDismissTimeout={ALERT_DISMISS_MS}>
          <HashRouter>
            <AuthBootstrap />
            <App />
          </HashRouter>
        </ToastProvider>
      </PersistGate>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
